<div class="repeat-section">
  <legend *ngIf="props.label">{{ props.label }}</legend>
  <p *ngIf="props.description">{{ props.description }}</p>

  <div class="field-row field-header">
    <ng-container *ngFor="let field of this.field.fieldGroup[0].fieldGroup">
      <div *ngIf="field?.props?.label">
        <div class="field-label" [matTooltip]="props.tooltipData.get(field?.props?.label)">{{ field?.props?.label }}</div>
      </div>
    </ng-container>
    <div class="remove-button"></div>
  </div>
  <div *ngFor="let field of field.fieldGroup; let i = index" class="field-row">
    <formly-field class="field-input" [field]="field"></formly-field>
    <div class="col-3 d-flex align-items-center">
      <button mat-icon-button color="primary" (click)="openConfirmationDialog(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>

  <div style="margin: 30px 0;">
    <div *ngIf="field.fieldGroup.length >= 10" class="max-rows-message">Maximum of 10 rows reached.</div>
    <button mat-flat-button color="primary" (click)="add()"
      [disabled]="!this.form.valid || field.fieldGroup.length>=10">{{ props?.addText }}</button>
  </div>
</div>
